export default __webpack_public_path__ + "static/media/Img401.5565474e.jpg";